<template>
    <div style="display: flex;align-items: center;">
        <div style="background: #333333;width: 4px;height: 4px;border-radius: 50%;"></div>
        <div style="font-size: 14px;color: #333333;margin-left: 8px;">{{item.GItemName}}</div>
        <div style="font-size: 14px;color: #333333;flex:1;text-align: right;">{{item.Value}}</div>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => ({
                GItemName: '',
                Value: 0
            })
        }
    }
}
</script>